<template>
  <div class="matchSection">
    <h2>{{ $t('tournament.playerResults') }}: {{participant.person.name}}</h2>
    <div class="groupsection">
      <table class="matchTable" ><tbody>
      <tr class="header"><td>ronde</td><td colspan="3">partij / reden afwezigheid</td><td>rank</td><td>EW</td><td>KW</td><td>BP</td></tr>
      <template v-for="ranking in sortedRankings" v-bind:key="ranking.rankingId">
        <tr class="match" >
            <td>{{ranking.roundNumber}}</td>
            <td v-if="ranking.match != null"><a href="#" @click="loadOtherPlayerResults(ranking.match.whitePlayer)">{{ranking.match.whitePlayer.person.name}}</a></td>
            <td v-if="ranking.match != null" v-html="showResult(ranking.match.result)"></td>
            <td v-if="ranking.match != null" ><a href="#" @click="loadOtherPlayerResults(ranking.match.blackPlayer)">{{ranking.match.blackPlayer.person.name}}</a></td>
            <td v-if="ranking.absence != null" colspan="3">Afwezig reden: {{reasonName(ranking.absence.reasonId)}}</td>
            <td>{{ranking.rank}}</td>
            <td>{{ranking.value}}</td>
            <td>{{ranking.score}}</td>
            <td>{{ranking.points}}</td>
        </tr>
        <tr v-if="ranking.roundNumber == rounds.length - 1"><td colspan="8">
          <div><a href="#/" @click="showCalculation = !showCalculation">
            <font-awesome-icon class="info" icon="info-circle" /> berekening van de Keizer waarde van de laatste ronde</a></div>
          <div v-if="showCalculation" v-html="showRoundCalculation(ranking)"></div>
        </td></tr>
      </template>
      </tbody></table>  
    </div>
    <h4 class="groupheader">
      <button class="button-icon square-icon w3-right" title="show legend" @click="showLegend = !showLegend" v-show="showLegend===false"><font-awesome-icon icon="caret-square-down" /></button>
      <button class="button-icon square-icon w3-right" title="hide legend" @click="showLegend = !showLegend" v-show="showLegend"><font-awesome-icon icon="caret-square-up" /></button>
      legenda
    </h4>
    <div class="legenda" v-if="showLegend">
      <br/>
      Rank: Plaats op de ranglijst.<br/>
      EW: Eigen waarde.<br/>
      <div class="explanation">De waarde van de speler aan het begin van de ronde. Speler 1 in de ranglijst heeft 100 punten, iedere volgende speler telkens 2 punten minder.</div>
      KW: Keizer waarde.<br/>
      <div class="explanation">De totaalscore van de speler aan het eind van de ronde. Deze waarde wordt berekend door bij de waarde van de vorige ronde de score van deze ronde op te tellen. Wat er bij op geteld wordt, hangt af van het resultaat:<br/>
      Winst: de waarde van je tegenstander<br/>
      Remise: de helft van de waarde van je tegenstander<br/>
      Verlies: geen ophoging van je totaalscore</div>
      BP: Bordpunten.<br/>
      <div class="explanation">Dit zijn de opgetelde punten van de gespeelde partijen. 1 voor winst, een half voor remise, 0 voor verlies.</div>
    </div>
  </div>
</template>


<script>
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const myInit = { 
  response: false,
};

export default {
  name: 'PlayerResults',
  props: {
    participant: Object,
    rounds: { type: Array, required: false, default: () => [{ roundId: 0, name: "No rounds provided" }] }
  },
  emits: ['update-player'],
  data: function () {
    return {
      absencesLoaded: false,
      absenceScores: [],
      matches: [],
      matchesLoaded: false,
      participantId: -1,
      prevRoundRankings: [], // to determine opponent values.
      rankings: [{match:null, absence:null}],
      rankingsLoaded: false,
      ratings: [],
      reasons: [{reasonId:"1", name:"absent with message"},
                {reasonId:"2", name:"absent without message"},
                {reasonId:"3", name:"absent for club"},
                {reasonId:"4", name:"manual bye"}],
      showCalculation: false,
      showLegend: false,
      sortedRankings: []
    }
  },
  beforeMount() {
    this.loadAbsenceScores();
    this.loadParticipantMatches();
    this.loadParticipantRankings();
    this.loadParticipantAbsences();
    this.loadPrevRoundRankings();
  },
  computed: {
    loadingComplete() {
      return (this.rankingsLoaded && this.absencesLoaded && this.matchesLoaded);
    } 
  },
  methods: {
    combineInfo(that) {
      //combine matches, absences and rankings in one structure, for easier representation
      console.log("combining " + that.rankings.length + " lines...");
      // lets add the match or absence to each ranking.
      that.rankings.forEach(function (ranking) {
          var match = that.matches.find(m => m.roundId === ranking.roundId);
          if (match != null) {
            ranking.match = match;
          } else {
            var absence = that.absences.find(a => a.roundId === ranking.roundId);
            console.log("absence found:" + JSON.stringify(absence));
            if (absence != null)
              ranking.absence = absence;
          }

          var round = that.rounds.find(m => m.roundId === ranking.roundId);
          ranking.roundNumber = round.number;
        });

      console.log("Combined lines:" + that.rankings.length);

      that.sortedRankings = that.sortRankings(that);
    },

    loadOtherPlayerResults(player) {
      console.log('emitting new player');
      this.$emit("update-player", player); 
    },

    loadParticipantAbsences: function() {
      let path = '/absence?tournamentId=' + this.participant.tournamentId + '&personId=' + this.participant.personId;
      let that = this
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          console.log("absences loaded")
          that.absences = response;
          that.absencesLoaded = true;
          if (that.loadingComplete) {
            that.combineInfo(that);
          }
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    loadParticipantMatches: function() {
      console.log("participant to load: " + JSON.stringify(this.participant));
      let path = '/match?tournamentId=' + this.participant.tournamentId + '&personId=' + this.participant.personId;
      let that = this
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          console.log("matches loaded")
          that.matches = response;
          that.matchesLoaded = true;
          if (that.loadingComplete) {
            that.combineInfo(that);
          }
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    loadParticipantRankings: function() {
      let path = '/ranking?tournamentId=' + this.participant.tournamentId + '&participantId=' + this.participant.participantId;
      let that = this
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          console.log("rankings loaded " + JSON.stringify(response));
          that.rankings = response;
          that.rankingsLoaded = true;
          console.log(that.rankings.length + " lines loaded")
          if (that.loadingComplete) {
            that.combineInfo(that);
          }
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    loadPrevRoundRankings() {
      if (this.rounds.length > 1) {
        // Find the last 'Played' round.
        var previousRoundIndex = this.rounds.length-2; //0-based
        while (this.rounds[previousRoundIndex].status != 'Played' && previousRoundIndex > 0)
          previousRoundIndex--;
        if (this.rounds[previousRoundIndex].status == 'Played' && previousRoundIndex > 0) {
          //and _then_ get the previous 
          var roundId = this.rounds[previousRoundIndex-1].roundId;

          let path = '/ranking?roundId=' + roundId;
          let that = this
          RestAPI
            .get(apiName, path, myInit)
            .then(response => {
              that.prevRoundRankings = response;
            })
            .catch(error => {
              console.log(error.response);
            });
        }      
      }
    },

    loadAbsenceScores: function() { 
      const myInit = { 
        response: false
      };
      let completePath = '/score?absentOnly=true&tournamentId=' + this.participant.tournamentId;
      let that = this;
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.absenceScores = response;
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("Error", JSON.stringify(error));
          }
        });
    },

    reasonName: function(reasonId) {
      var score = this.absenceScores.find(item => item.scoreId == reasonId);
      return score.name;
    },

    showResult(resultNumber) {
      var result = " - ";
      switch (resultNumber) {
        case 0:
          result = " - ";
          break;
        case 1:
          result = "1-0";
          break;
        case 2:
          result = "0-1";
          break;
        case 3:
          result = "&frac12;-&frac12;";
          break;
      }
      return result;
    },

    showRoundCalculation: function(ranking) {
      console.log("test");
      
      var ownValue = this.rankings.find(r => r.roundNumber == ranking.roundNumber-1).value;
      var total = ownValue;
      var msg = "eigen waarde: " + total + "<br/>";
      for (var roundLoop = 1; roundLoop <= ranking.roundNumber; roundLoop++) {
        msg = msg + roundLoop + ". ";
        var roundRanking = this.rankings.find(r => r.roundNumber == roundLoop);
        console.log("rankings 1: " + JSON.stringify(roundRanking));
        var match;

        if (roundRanking.match != null) {
          match = roundRanking.match;
          console.log("match 1: " + JSON.stringify(match));
          var opponent = "";
          var opponentValue = 0;

          console.log("match: " + JSON.stringify(match));
          if (match.whitePlayerId == ranking.participantId) {
            opponent = match.blackPlayer;
            opponentValue = this.prevRoundRankings.find(r => r.participantId == opponent.participantId).value;
            switch (match.result) {
              case 1: //1-0
                msg = msg + "gewonnen van ";
                total = total + opponentValue;
                msg = msg + opponent.person.name + ": " + opponentValue;
                break;
              case 3: //0,5-0,5
                total = total + (0.5 * opponentValue);
                msg = msg + "remise tegen ";
                msg = msg + opponent.person.name + ": " + (0.5 * opponentValue);
                break;
              case 2: //0-1
                msg = msg + "verloren van ";
                msg = msg + opponent.person.name + ": 0";
                break;
            }
          } else {
            opponent = match.whitePlayer;
            opponentValue = this.prevRoundRankings.find(r => r.participantId == opponent.participantId).value;
            switch (match.result) {
              case 1: //1-0
                msg = msg + "verloren van ";
                msg = msg + opponent.person.name + ": 0";
                break;
              case 3: //0,5-0,5
                total = total + (0.5 * opponentValue);
                msg = msg + "remise tegen ";
                msg = msg + opponent.person.name + ": " + (0.5 * opponentValue);
                break;
              case 2: //0-1
                total = total + opponentValue;
                msg = msg + "gewonnen van ";
                msg = msg + opponent.person.name + ": " + opponentValue;
                break;
            }
          }
        } else {
          if (roundRanking.absence != null) {
            var score = this.absenceScores.find(item => item.scoreId == roundRanking.absence.reasonId);
            msg = msg + "geen partij - " + score.name + ": " + (score.value * ownValue);
            total = total + Math.round(score.value * ownValue);

          }
        }
        msg = msg + " (tussentotaal:" + total + ")<br/>";
      }
 
      return msg;
    },

    sortRankings(that) {
      return Array.from(that.rankings).sort((a, b) => {
        if (a.roundNumber < b.roundNumber) {
          console.log("sorting " + a.roundNumber);
          return -1;
        }
        if (a.roundNumber > b.roundNumber) {
          return 1;
        }
        return 0;
      })
    }
  }
}
</script>

<style scoped>
h6 a {
  margin-left: 4px;
}

a {
  text-decoration: none;
}

a:hover {
  color: #365c96; 
  transition: color .3s linear;
}

.explanation {
  margin-left: 15px;
}

td {
  padding-left: 8px;
}

.groupItem {
  font-weight: bold;
}

.groupsection {
  margin-right: 2vw;
}

.header td {
    color: white;
  }

.imgbtn {
  float: right;
  border: 1px solid #333333;
  border-radius: 2px;
}

.lastCol {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
  width: 50px;
}

.matchTable {
  width: 100%;
  max-width: 100%;
  margin: 0vw 2vw;
  border: 1px solid #181818;
  border-radius: 2px;
  overflow-x: auto;
  box-sizing: border-box;
}

.tdRight {
  width: auto;
  text-align: right;
}

.xtendCol {
  width: auto;
}

tr:nth-child(odd) {
  background-color: #181818;
}


/* mobile */
@media screen and (max-width: 600px) {
  .details {
    padding: 0vw 2vw;
  }
  .container {
    padding: 2vw 0.5vw;
    width: 100%;
    overflow-x: auto;
  }

  .matchTable {
    width: 100%;
    max-width: 100%;
    margin: 0vw 1vw;
    overflow-x: auto;
    display: block;
    -webkit-overflow-scrolling: touch;
  }

  .matchTable table {
    min-width: 100%;
    white-space: nowrap;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .details {
    padding: 0vw 2vw;
  }
  .container {
    padding: 2vw 0.5vw;
    width: 100%;
  }

  .matchTable {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .details {
    padding: 0vw 2vw;
  }
  .container {
    padding: 2vw 0.5vw;
  }
}

</style>

